import type {
  ScaleAssessment,
  ScaleFinding,
} from "@constructionautomation/backend/convex/lib/drawingScale";
import { Button } from "@/components/ui/button";

export function AiPageScaleStatus({
  assessmentJson,
  debug = false,
  disabled,
  onConfirm,
}: {
  assessmentJson?: string;
  debug?: boolean;
  disabled: boolean;
  onConfirm: () => void;
}) {
  if (!assessmentJson) return null;
  const assessment = JSON.parse(assessmentJson) as ScaleAssessment & {
    finding?: ScaleFinding;
  };
  const needsConfirmation = assessment.state === "needs_confirmation";
  // A settled scale is routine: name it in one line unless the user must act or is debugging.
  if (!needsConfirmation && !debug) {
    return assessment.printedText ? <p className="text-xs text-muted-foreground">Page scale: {assessment.printedText}</p> : null;
  }
  return (
    <div className="space-y-2 rounded-md border-2 p-3" aria-label="Page scale">
      <p className="font-medium">
        Page Scale{assessment.printedText ? `: ${assessment.printedText}` : ""}
      </p>
      <p role="status" className="text-muted-foreground">{assessment.reason}</p>
      {needsConfirmation && (
        <Button size="sm" variant="outline" disabled={disabled} onClick={onConfirm}>
          Confirm printed scale for this page
        </Button>
      )}
      {debug && assessment.finding && (
        <div className="space-y-1 border-t pt-2 text-xs text-muted-foreground">
          <p>{assessment.finding.evidence}</p>
          {assessment.finding.dimension && <p>Dimension checked: {assessment.finding.dimension.label}</p>}
          {assessment.finding.warnings.map((warning, i) => <p key={i}>{warning}</p>)}
        </div>
      )}
    </div>
  );
}
